/**
 * /frontend/src/features/analytics/components/offers/OfferInteractionPieChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import DistributionPieChart from '../charts/DistributionPieChart';

/**
 * Offer interaction distribution.
 * @param {{data:Array<{name:string,value:number}>}} props
 * @returns {JSX.Element}
 */
const OfferInteractionPieChart = ({ data }) => (
  <ChartContainer title="Offer Interactions" subtitle="Viewed vs claimed vs redeemed">
    <DistributionPieChart data={data} nameKey="name" valueKey="value" />
  </ChartContainer>
);

export default OfferInteractionPieChart;

